const WikiHistory = () => {
  return <div>Wiki.History</div>;
};

export default WikiHistory;
